import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { decodeIdToken, type IdTokenClaims } from '@logto/js';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { UserPreferencesApi } from '../../api/user-preferences/user-preferences-api.service';
import { fullRouteNavItems } from '../../constants/navbar.constants';
import { FullRouteNavItem } from '../../models/nav-item.model';
import { UserPermissionsService } from '../../services/user-permissions.service';
import { ProductSearchDialogComponent } from '../product-search-dialog/product-search-dialog.component';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent implements OnInit, AfterViewInit {
  currentModule?: string;
  favouriteShoppingListId: number | null = null;
  isMobile = true;
  isAuthenticated = false;
  userName?: string;
  userPicture?: string;
  navItems: FullRouteNavItem[] = [];

  constructor(
    private observer: BreakpointObserver,
    private cdr: ChangeDetectorRef,
    private matDialog: MatDialog,
    private router: Router,
    private oidcSecurityService: OidcSecurityService,
    private userPreferencesApi: UserPreferencesApi,
    readonly userPermissions: UserPermissionsService
  ) {}

  ngOnInit() {
    this.observer.observe(['(max-width: 800px)']).subscribe(screenSize => {
      this.isMobile = screenSize.matches;
    });

    this.oidcSecurityService.isAuthenticated$.subscribe(({ isAuthenticated }) => {
      this.isAuthenticated = isAuthenticated;
      if (isAuthenticated) {
        this.userPermissions.load().subscribe({
          next: () => this.updateNavItems(),
          error: () => {
            this.userPermissions.clear();
            this.updateNavItems();
          },
        });
        this.loadUserPreferences();
      } else {
        this.favouriteShoppingListId = null;
        this.userPermissions.clear();
        this.updateNavItems();
      }
    });

    this.oidcSecurityService.getIdToken().subscribe(idToken => {
      if (idToken) {
        const claims: IdTokenClaims = decodeIdToken(idToken);
        this.userName = claims.name ?? claims.username ?? undefined;
        this.userPicture = claims.picture ?? undefined;
      }
    });
  }

  private loadUserPreferences(): void {
    this.userPreferencesApi.get().subscribe({
      next: prefs => {
        this.favouriteShoppingListId = prefs.favouriteShoppingListId;
      },
      error: () => {
        this.favouriteShoppingListId = null;
      },
    });
  }

  private updateNavItems(): void {
    this.navItems = fullRouteNavItems.filter(
      item => !item.permission || this.userPermissions.hasPermission(item.permission)
    );
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.router.events.subscribe(() => {
      this.currentModule = this.router.url.split('/')[1];
    });
  }

  openMobileProductSearchDialog(): void {
    this.matDialog.open(ProductSearchDialogComponent, {
      minWidth: '70%',
    });
  }

  signIn(): void {
    this.oidcSecurityService.authorize();
  }

  signOut(): void {
    this.userPermissions.clear();
    this.oidcSecurityService.logoff().subscribe();
  }
}
